package com.neurobs.js.ccab

import com.neurobs.ccab.ErrorCreateData
import com.neurobs.util.{JsonPrinter, Logger, SecondsTimestamp}

import io.circe.generic.auto._

/** Logger that logs errors with the CCAB server before passing them to a wrapped Logger
 *
 * @param wrapped Logger called after preprocessing for all methods
 */
class DatabaseErrorLogger(val wrapped: Logger) extends Logger {
	import DatabaseErrorLogger._

	var userId: Option[Long] = None

	override def log(s: String): Unit = wrapped.log(s)

	override def debug(s: String): Unit = wrapped.debug(s)

	override def error(s: String): Unit = {
		val errorData: Data = Data(userId = userId, error = s)
		val content = JsonPrinter.jsonPrint(data = errorData)
		val error = ErrorCreateData(eventTime = SecondsTimestamp.now(), `class` = errorClass, `type` = errorType, content = content, contentType = contentType)
		CCABServer.createError(data = error)(_ => Unit)

		wrapped.error(s)
	}

	override def warn(s: String): Unit = wrapped.warn(s)
}

object DatabaseErrorLogger {
	val errorClass = "error"
	val errorType = "examiner"
	val contentType = "application/json"

	case class Data(userId: Option[Long], error: String)
}